<script lang="ts">
	import type { ClassValue } from "svelte/elements";

	// Accepts slot of phrasing content
	type Props = {
		class?: ClassValue;
		children?: import("svelte").Snippet;
	};

	let { class: classes = "", children }: Props = $props();
</script>

<p class={["lead-component-element text-lead", classes]}>
	{@render children?.()}
</p>

<style lang="postcss">
	:global(:where(.lead-component-element)) {
		margin-block-end: var(--lead-mb, var(--space));
		max-width: var(--lead-width, unset);
	}
</style>
